import { state as defaultState, UtilityState } from '@/store/modules/utility/state';
import { actions } from '@/store/modules/utility/actions';
import { mutations } from '@/store/modules/utility/mutations';
import { getters } from '@/store/modules/utility/getters';
import { Module } from 'vuex';
import { RootState } from '@/store/state';

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  mutations,
  getters
} as Module<UtilityState, RootState>;
